module.exports = __webpack_public_path__ + "img/ring_g_o_0_null@2x.1ccb46c9.png";